import * as React from 'react'
import QueryString from 'query-string'
import { replace } from 'react-router'
import { withScrollToTop } from '../../common/modules/scroll-to-top'

@withScrollToTop
export default class extends React.Component<any, any>{


    componentWillMount(){
        const query = QueryString.parse(QueryString.extract(window.location.href));
        
        const referenceCode = query.referenceCode || "";
        const utm_source = query.utm_source || "" ;
        const utm_medium = query.utm_medium || "" ;
        const utm_campaign = query.utm_campaign || "" ;
        const utm_term = query.utm_term || "";
        const utm_content = query.utm_content || "";
        const utm_referrer = query.utm_referrer || "";        
        
        let urlSuffix = referenceCode ? '?' : '';
       
        
        if(referenceCode){
            urlSuffix += 'referenceCode=' +referenceCode.trim();
        }
        if(utm_source){
            urlSuffix += '&utm_source=' +utm_source;
        }
        if(utm_medium){
            urlSuffix += '&utm_medium=' +utm_medium;
        }
        if(utm_campaign){
            urlSuffix += '&utm_campaign=' +utm_campaign;
        }
        if(utm_term){
            urlSuffix += '&utm_term=' +utm_term;
        }
        if(utm_content){
            urlSuffix += '&utm_content=' +utm_content;
        }
        if(utm_referrer){
            urlSuffix += '&utm_referrer=' +utm_referrer;
        }


        
        
        urlSuffix = urlSuffix.replace("#/", "")

        const project = process.env.REACT_APP_PROJECT;

        if(window.location.href.indexOf("restore") == -1){
          
            if(project == "landing"){
                 const newPath = window.location.origin + window.location.pathname + "#/" + urlSuffix;
                 window.location.replace(newPath);
            }

            else{
                const newPath = window.location.origin + window.location.pathname + "#/step-1" + urlSuffix;
                window.location.replace(newPath);
            }


         }
    }


    render(){
        return null;
    }


}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/routes/index-route.tsx